<mat-card appearance="outlined" *ngIf="authService.isAdmin()">

  <app-overlay-spinner *ngIf="isBusy()"></app-overlay-spinner>

  <mat-card-header>
    <mat-card-title>{{ 'TOOLS.NEW_CALC' | translate }}</mat-card-title>
  </mat-card-header>
  
  <mat-card-actions>

    <mat-form-field class="card">
      <input
        matInput
        [matDatetimepicker]="startPicker"
        placeholder="{{ 'TRIP.FROM_TITLE' | translate }}"
        (dateChange)="intervalChange({ startTimeFrom: $event.value })"
        [max]="maxDate"
        autocomplete="off"
        [formControl]="myControlStartDate"
        [errorStateMatcher]="errorStateMatcher"
      />
      <mat-error *ngIf="!startDateValid">{{ 'TRIP.INVALID_DATE' | translate }}</mat-error>
      <mat-datetimepicker-toggle matSuffix [for]="startPicker"></mat-datetimepicker-toggle>
      <mat-datetimepicker #startPicker type="datetime"> </mat-datetimepicker>
    </mat-form-field>

    <mat-form-field class="card">
      <input
        matInput
        [matDatetimepicker]="endPicker"
        placeholder="{{ 'TRIP.TO_TITLE' | translate }}"
        (dateChange)="intervalChange({ startTimeTo: $event.value })"
        [max]="maxDate"
        autocomplete="off"
        [formControl]="myControlEndDate"
        [errorStateMatcher]="errorStateMatcher"
      />
      <mat-error *ngIf="!endDateValid">{{ 'TRIP.INVALID_DATE' | translate }}</mat-error>
      <mat-datetimepicker-toggle matSuffix [for]="endPicker"></mat-datetimepicker-toggle>
      <mat-datetimepicker #endPicker type="datetime"></mat-datetimepicker>
    </mat-form-field>

    <mat-form-field class="card">
      <mat-chip-grid #chipListRecalculateGroup>
        <mat-chip-row 
          class="trips-tools-mat-chip"
          *ngIf="selectedGroup"
          (removed)="selectGroup(null)">
          {{selectedGroup.groupName}}
          <mat-icon matChipRemove >cancel</mat-icon>
        </mat-chip-row>
        <input *ngIf="!selectedGroup"
          type="text"
          placeholder="{{ 'TRIP.GROUPNAME' | translate }}"
          matInput
          [formControl]="formControlGroup"
          [matAutocomplete]="autoGroupMap"
          [matChipInputFor]="chipListRecalculateGroup"
        />
      </mat-chip-grid>
      <mat-autocomplete
        #autoGroupMap="matAutocomplete"
        (optionSelected)="selectGroup($event.option.value)"
        [displayWith]="displayGroup"
      >
    <mat-option *ngFor="let group of filteredGroups | async" [value]="group">
        <span hierarchicalGroupStyle [groupPath]="group.groupIdentifier">
          {{ group.groupIdentifier | hierarchicalGroup }}
        </span>
    </mat-option>
      </mat-autocomplete>
    </mat-form-field>

  </mat-card-actions>
    
  <mat-card-actions>
    <button mat-raised-button color="primary" (click)="recalcSubmit()" [disabled]="isRecalcSubmitDisabled() || isBusy()">
      {{ 'TOOLS.NEW_CALC' | translate }}
    </button>
  </mat-card-actions>

</mat-card>

<br>

<mat-card appearance="outlined" *ngIf="authService.isAdminOrDispatcher()">
  <mat-card-header>
    <mat-card-title>{{ 'TOOLS.CLEAR_EMPTY_TRIPS' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-checkbox [(ngModel)]="withPositions">{{ 'TOOLS.CLEAR_EMPTY_TRIPS_WITHPOSITIONS' | translate }}</mat-checkbox>
  </mat-card-content>
  <mat-card-actions>
    <button mat-raised-button color="primary" (click)="clearEmptySubmit()" [disabled]="isBusy()">
      {{ 'TOOLS.CLEAR_EMPTY_TRIPS' | translate }}
    </button>
  </mat-card-actions>
</mat-card>

<br>

<mat-card appearance="outlined" *ngIf="authService.isAdmin()">

  <mat-card-header>
    <mat-card-title>{{ 'TOOLS.SHOW_TRIP' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-actions>
  <mat-form-field class="card">
    <mat-chip-grid #chipListShowTrip>
      <mat-chip-row 
        class="trips-tools-mat-chip"
        *ngIf="selectedGroupShowTrip"
        (removed)="selectGroupShowTrip(null)">
        {{selectedGroupShowTrip.groupName}}
        <mat-icon matChipRemove >cancel</mat-icon>
      </mat-chip-row>
      <input *ngIf="!selectedGroupShowTrip"
        type="text"
        placeholder="{{ 'TRIP.GROUPNAME' | translate }}"
        matInput
        [formControl]="formControlGroup"
        [matAutocomplete]="autoGroupMap"
        [matChipInputFor]="chipListShowTrip"
      />
    </mat-chip-grid>
    <mat-autocomplete
      #autoGroupMap="matAutocomplete"
      (optionSelected)="selectGroupShowTrip($event.option.value)"
      [displayWith]="displayGroup"
    >
    <mat-option *ngFor="let group of filteredGroups | async" [value]="group">
      <span hierarchicalGroupStyle [groupPath]="group.groupIdentifier">
        {{ group.groupIdentifier | hierarchicalGroup }}
      </span>
    </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      type="text"
      placeholder="{{ 'TOOLS.TRIPID' | translate}}"
      [(ngModel)]="tripIdShowTrip"
      (input)="clearTripIdShowTripErrorMsg()"
      autocomplete="off"
    />
   
    <button mat-button *ngIf="tripIdShowTrip" matSuffix mat-icon-button aria-label="Clear" (click)="clearTripIdShowTrip()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</mat-card-actions>
<mat-card-actions>
    <button 
      mat-raised-button
      [disabled]="disableShowTripButton()"
      color="primary"
      (click)="showTripDetailsByTripId()"
    >
      {{ 'TOOLS.SHOW_TRIP' | translate }}
    </button>
  </mat-card-actions>

  <br>

  <mat-card *ngIf="tripIdShowTripErrorMsg !== null" class="error-field">
    <mat-card-header>
      <mat-card-title>{{ 'ERROR.OTHER' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-actions>
      <label>
        {{ tripIdShowTripErrorMsg | translate }}
      </label>
    </mat-card-actions>
  </mat-card>

</mat-card>
